export const ADMIN_PAGE_SIZE = 25;
export const ADMIN_LOOKUP_SIZE = 500;
export function emptyToNull(value) {
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
}
export function optionalNumber(value) {
    const trimmed = value.trim();
    if (!trimmed)
        return null;
    const n = Number(trimmed);
    return Number.isFinite(n) ? n : null;
}
